// extracted by mini-css-extract-plugin
export default {"name":"familyRow__name-u0apF","apps":"familyRow__apps-gyNdA","menu":"familyRow__menu-pdvgJ"};